import { inject, Injectable, signal } from '@angular/core';
import { SharedService } from './shared.service';

@Injectable({
  providedIn: 'root'
})
export class ImageViewerService {
  
  sharedService = inject(SharedService);
  imageUrl = signal<string | null>(null);
  visible = signal(false);

  open(imageUrl: string) {

    if (!imageUrl || (imageUrl.split('/').pop() === this.sharedService.noImage.split('/').pop())) return;

    this.imageUrl.set(imageUrl);
    this.visible.set(true);
  }

  close() {
    this.visible.set(false);
    this.imageUrl.set(null);
  }
}
